/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, OnInit, Injector, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, FormsModule } from '@angular/forms';
import { SelectOption } from '../input.models';
import { CustomErrorDisplayComponent } from '../custom-error-display/custom-error-display.component';

@Component({
  selector: 'lib-custom-checkbox-group',
  standalone: true,
  imports: [FormsModule, CustomErrorDisplayComponent],
  templateUrl: './custom-checkbox-group.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomCheckboxGroupComponent),
      multi: true,
    },
  ],
})
export class CustomCheckboxGroupComponent implements ControlValueAccessor, OnInit {
  label = input<string>('');
  options = input<SelectOption[]>([]);
  layout = input<'vertical' | 'horizontal'>('vertical');
  errors = input<{ [key: string]: string }>({});
  mb = input<boolean>(true);
  idPrefix = input<string>('');

  _value: any[] = []; // Stores an array of selected values
  isDisabled: boolean = false;
  ngControl: NgControl | null = null;

  onChange: (value: any[]) => void = () => {};
  onTouched: () => void = () => {};

  constructor(private _injector: Injector) {}

  ngOnInit(): void {
    this.ngControl = this._injector.get(NgControl, null);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: any[]): void {
    this._value = Array.isArray(value) ? [...value] : [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  toggleSelection(optionValue: any): void {
    if (this.isDisabled) {
      return;
    }
    const index = this._value.indexOf(optionValue);
    if (index > -1) {
      this._value.splice(index, 1); // Remove if exists
    } else {
      this._value.push(optionValue); // Add if not exists
    }
    this.onChange([...this._value]); // Emit a new array instance
    this.onTouched();
  }

  isSelected(optionValue: any): boolean {
    return this._value.includes(optionValue);
  }

  // Helper for unique IDs in template
  getCheckboxId(optionValue: any, index: number): string {
    const namePrefix = this.idPrefix() || this.ngControl?.name || 'checkbox-group';
    return `${namePrefix}-${optionValue?.toString().replace(/\s+/g, '-') || index}`;
  }
}
